import { render, staticRenderFns } from "./MonthPrice.vue?vue&type=template&id=420b537e&scoped=true"
import script from "./MonthPrice.vue?vue&type=script&lang=js"
export * from "./MonthPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420b537e",
  null
  
)

export default component.exports